var map = {
	"./047---Archer.json": 79065,
	"./048---Grenader.json": 50104,
	"./049---ClusterGrenader.json": 50757,
	"./050---Scorpio.json": 27591,
	"./051---Hammer.json": 11345,
	"./052---AxeThrower.json": 81349,
	"./053---PirateChief.json": 92608,
	"./054---Spiker.json": 14612,
	"./055---Mage360.json": 68257,
	"./056---OrbLauncher.json": 72945,
	"./057---DeathMage.json": 12799,
	"./058---KunaiMaster.json": 28864,
	"./059---Arbiter.json": 47634,
	"./060---Minimoth.json": 94140,
	"./061---Pitcher.json": 59526,
	"./062---Blowgunner.json": 43807,
	"./063---Hurler.json": 43402,
	"./064---CrossbowMan.json": 68911,
	"./065---BootlegHomunculus.json": 29905,
	"./066---BootlegBowman.json": 77050,
	"./067---AnchorGuy.json": 6389,
	"./068---BoneThrower.json": 26023,
	"./069---Merman.json": 21065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45010;